import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type NewsSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_NEWS_SORT_OPTION: NewsSortOption = "newest";

const OPTIONS: SortOption<NewsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function newsSortOptionLabel(option: NewsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function newsSortOptionToParams(option: NewsSortOption): {
  sortBy: "created_at" | "title";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "created_at", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "created_at", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "title", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "title", sortOrder: "DESC" };
  }
}

export default function SortNewsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: NewsSortOption;
  setSortOption: (option: NewsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort News"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
